import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import locationsSlice from '../reducers/locations.slice'

const persistConfig = {
  key: 'locationsSlice',
  storage,
}

export const persistedLocationsReducer = persistReducer(persistConfig, locationsSlice)